import * as React from 'react';
import './Layout.scss';

import { IPanelAppContext } from '~/lib/AppContext';
import Announcer from './Announcer';
import Header from './Header';
import NotificationCenter from './NotificationCenter';
import ConfirmModalHost from '~/components/ConfirmModalHost';
import ErrorModalHost from '~/components/ErrorModalHost';
import { observer } from 'mobx-react';
import Search from './Search';
import Sidebar from './Sidebar';
import { MainNavigation } from './MainNavigation';

type AppProps = {
    children?: React.ReactNode;
    appContext: IPanelAppContext;
};

@observer
export default class App extends React.Component<AppProps> {
    render() {
        return (
            <div id="root" className={this.props.appContext.customer.isAdminLogin ? 'is-admin' : ''}>
                <a href="#main-content" className="skipToContent">
                    Skip to content
                </a>
                <Header />
                <Announcer />
                <NotificationCenter />
                <ConfirmModalHost />
                <ErrorModalHost />
                <Search />
                <div className="d-flex flex-row h-100">
                    <div className="sidebarContainer">
                        <Sidebar location={window.location}>
                            <MainNavigation
                                location={window.location}
                                currentUserEmail={this.props.appContext.customer.item?.email}
                            />
                        </Sidebar>
                    </div>
                    <main id="main-content" className="px-2 px-md-4 bl-main-content">
                        {this.props.children}
                    </main>
                </div>
            </div>
        );
    }
}
